import { Button, Box, Typography } from '@mui/material'
import { FacebookPage } from '@promoboxx/graphql-gateway-types'
import I18n from 'i18n-js'
import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => {
  return {
    requestBusinessManager: {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.secondary.contrastText,
    },
  }
})

interface RequestBusinessManagerPermissionsProps {
  facebookPage: FacebookPage
  manualBusinessRequest: (id: string) => Promise<FacebookPage>
}
export function RequestBusinessManagerPermissions({
  facebookPage,
  manualBusinessRequest,
}: RequestBusinessManagerPermissionsProps) {
  const { enqueueSnackbar } = useSnackbar()
  const { classes } = useStyles()

  const [businessManagerRequestAt, setBusinessManagerRequestAt] =
    useState<Date | null>(
      facebookPage?.manual_business_manager_requested_at
        ? new Date(String(facebookPage?.manual_business_manager_requested_at))
        : null,
    )
  const [disabled, setDisabled] = useState(businessManagerRequestAt !== null)

  const handleRequestBusinessManagerPermissions = () => {
    manualBusinessRequest(facebookPage.id)
      .then((updatedFacebookPage?: FacebookPage) => {
        if (updatedFacebookPage?.manual_business_manager_requested_at) {
          setBusinessManagerRequestAt(
            new Date(
              String(updatedFacebookPage?.manual_business_manager_requested_at),
            ),
          )
        }
      })
      .catch((error: Error) => {
        enqueueSnackbar(
          I18n.t(
            'facebookPermissionsManager.requestBusinessManagerPermissionsError',
          ),
          {
            variant: 'error',
          },
        )
        console.error('Error requesting business manager permissions', error)
      })
    setBusinessManagerRequestAt(new Date())
    setDisabled(true)
  }

  if (!facebookPage.business_manager_permissions) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
      >
        <Button
          className={classes.requestBusinessManager}
          color={'secondary'}
          disabled={disabled}
          onClick={handleRequestBusinessManagerPermissions}
          size={'small'}
          variant={'contained'}
        >
          {I18n.t('facebookPermissionsManager.request')}
        </Button>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          pt={2}
        >
          <Typography variant={'caption'} style={{ textAlign: 'center' }}>
            {disabled && businessManagerRequestAt
              ? I18n.t(
                  'facebookPermissionsManager.requestBusinessManagerPermissionsDisabled',
                  {
                    date: businessManagerRequestAt?.toLocaleString('en-us', {
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    }),
                  },
                )
              : I18n.t(
                  'facebookPermissionsManager.requestBusinessManagerPermissions',
                )}
          </Typography>
        </Box>
      </Box>
    )
  } else {
    return null
  }
}
